<!-- Copyright (c) 2021 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="doc-status-main">
    <!-- <button @click="openClosePopup(true)">{{ buttonText }}</button> -->

    <div v-if="pShowPopup" class="update-popup">
      <div class="update-content">
        <div class="title">{{ title }}</div>
        <Dropdown
          :items="categoryList"
          itemKey="desc"
          :selectedObject.sync="selectedCategory"
          placeholder="Select Document or Status"
          :isDisabled="defaultCategory != null"
        />

        <hr v-if="selectedCategory" />

        <!-- Document Update -->
        <div class="doc-update" v-if="selectedCategory ? selectedCategory['key'] == 'd' : false">
          <!-- Document Update UI -->
          <div class="top-section">
            <InputQuery
              placeholder="Doc Code"
              itemKey="Code - Description"
              descKey="Description"
              :isRequired="true"
              :items="pDocStatusList"
              :selectedObject.sync="selectedDocCode"
              :errorMessage.sync="docCodeError"
            />
            <Input
              placeholder="Doc Ref #"
              :isRequired="true"
              :inputValue.sync="docRef"
              :errorMessage.sync="docRefError"
              validator="text,25"
            />
          </div>
          <button
            class="collapse-expand-button"
            @click="collapseExpandClicked"
            v-if="selectedDocCode ? docCodeWithStatus.includes(selectedDocCode['Doc Code']) : false"
            >{{ collapseExpandTitle }}</button
          >
          <div
            class="status-scrollable"
            v-if="selectedDocCode ? docCodeWithStatus.includes(selectedDocCode['Doc Code']) : false"
          >
            <div
              class="status-section"
              v-for="(s, i) in allStatusesToBind"
              :key="i"
              :style="{
                maxHeight: s['expanded'] ? 'none' : '45px',
                border: s['visible'] ? '1px solid rgba(0,0,0,0.5)' : 'none',
                padding: s['visible'] ? '5px 5px 15px' : '0',
                paddingTop: s['visible'] ? '10px' : '0',
                marginTop: s['visible'] ? '10px' : '0',
                marginBottom: s['visible'] ? '10px' : '0',
              }"
            >
              <div class="status-wrapper" v-if="s['visible']">
                <CheckBox
                  class="status-title"
                  :title="`${s['docKey']} (${s['docStatus']})`"
                  :isChecked.sync="s['checked']"
                  @checkBoxClicked="statusChecked(i)"
                />
                <img
                  class="individual-collapse-expand-button"
                  src="https://dsmapi.logistics.systems/dsm6gicons/icons8-expand-arrow-24.png"
                  :style="{ transform: `rotate(${s['expanded'] ? '180' : '0'}deg)` }"
                  @click="individualCollapseExpand(i)"
                />
                <div v-if="s['expanded']" class="status-details-box">
                  <div class="status-details">
                    <DateTimePicker placeholder="Start" :value.sync="s['start']" :isDisabled="!s['checked']" />
                    <DateTimePicker placeholder="Received" :value.sync="s['received']" :isDisabled="!s['checked']" />
                    <DateTimePicker placeholder="Due Time" :value.sync="s['due']" :isDisabled="!s['checked']" />
                  </div>
                  <div class="status-details">
                    <div class="attchment-area">
                      <Input
                        placeholder="Attachment"
                        textType="file"
                        @fileChanged="docFileChangedWithStatus($event, i)"
                        :isDisabled="!s['checked']"
                      />
                      <div v-if="s['prevAttached']" style="font-weight: bold">Attached File</div>
                      <div v-if="s['prevAttached']" :title="s['prevAttached']">{{ s['prevAttached'] }}</div>
                    </div>
                    <RemarksBox :text.sync="s['remarks']" :isDisabled="!s['checked']" />
                    <div>
                      <Input
                        placeholder="Assign To"
                        :inputValue.sync="s['assignTo']"
                        :isDisabled="!s['checked']"
                        validator="text,10"
                      />
                      <div style="display: flex">
                        <Input
                          placeholder="Sets"
                          textAlign="right"
                          :inputValue.sync="s['sets']"
                          style="margin-right: 5px"
                          :isDisabled="!s['checked']"
                          validator="integer,1"
                        />
                        <Input
                          placeholder="Page"
                          textAlign="right"
                          :inputValue.sync="s['page']"
                          :isDisabled="!s['checked']"
                          validator="integer,4"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="status-details-box-collapse">
                  <DateTimePicker placeholder="Received" :value.sync="s['received']" :isDisabled="!s['checked']" />
                  <Input placeholder="Remarks" :inputValue.sync="s['remarks']" :isDisabled="!s['checked']" />
                  <Input placeholder="Assign To" :inputValue.sync="s['assignTo']" :isDisabled="!s['checked']" />
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="selectedDocCode">
            <Input
              textType="file"
              placeholder="Select Document"
              :multiFile="true"
              @fileChanged="docFileChangedWithoutStatus"
            />
            <div v-if="editDetailsList.length > 0">
              <div style="font-weight: bold">Attached Files:</div>
              <div v-for="(d, i) in filteredAttachments" :key="i"> {{ i + 1 }}. {{ d['Attachment'] }} </div>
            </div>
          </div>
        </div>

        <!-- Status Update -->
        <div class="status-update" v-else-if="selectedCategory ? selectedCategory['key'] == 's' : false">
          <div class="top-dates">
            <DateTimePicker placeholder="Start Time" :value.sync="startTime" />
            <!-- <DateTimePicker placeholder="Finished Date" :value.sync="finishTime" tabindex="1" /> -->
          </div>
          <DateTimePicker placeholder="Due Time" :value.sync="dueTime" />
          <div style="display: flex">
            <button @click="statusSelected(selectedStatus)" style="width: 170px; margin-right: 5px"
              >Get Default Value</button
            >
            <InputQuery
              placeholder="Status"
              :isRequired="true"
              :items="pStatusList"
              itemKey="display"
              descKey="Status Desc"
              @selected="statusSelected"
              :selectedObject.sync="selectedStatus"
              :errorMessage.sync="statusError"
              :isDisabled="editDetails ? true : false"
            />
          </div>
          <div class="excel-email-button">
            <Tooltip
              @click.native="downloadExcel"
              v-if="excel == 1"
              icon="https://dsmapi.logistics.systems/dsm6gIcons/ExportExcel.png"
              tooltipText="Download Excel"
              style="cursor: pointer; margin-right: 5px"
            />
            <Tooltip
              @click.native="sendEmail"
              v-if="email == 1"
              icon="https://dsmlib.logistics.systems/Icons/mail.png"
              tooltipText="Send Email"
              style="cursor: pointer; margin-right: 5px"
            />
          </div>
          <div class="internal-loading" v-if="loadStatus">
            Loading Status {{ statusValue }} . . .
            <div class="internal-spinner"></div>
          </div>
          <div v-else-if="noUIControl" style="color: red">{{ noUIControl }}</div>
          <div v-else-if="currentStatusUI.length > 0" class="dynamic-status">
            <div v-for="(c, i) in currentStatusUI" :key="i">
              <div v-if="Array.isArray(c)" class="dynamic-horizontal">
                <div v-for="(a, ai) in c" :key="ai">
                  <Input
                    v-if="a['type'] == 'Input'"
                    :placeholder="a['placeholder']"
                    :inputValue.sync="a['value']"
                    :textType="a['datatype']"
                    @fileChanged="dynamicFileChanged"
                    :isRequired="a['required'] == 1"
                    :errorMessage.sync="a['errorMessage']"
                  />
                  <Dropdown
                    v-if="a['type'] == 'Dropdown'"
                    :placeholder="a['placeholder']"
                    :items="a['data']"
                    :itemKey="a['postdata']['itemKey']"
                    :selectedObject.sync="a['value']"
                    :isRequired="a['required'] == 1"
                    :errorMessage.sync="a['errorMessage']"
                  />
                  <InputQuery
                    v-if="a['type'] == 'InputQuery'"
                    :placeholder="a['placeholder']"
                    :items="a['data']"
                    :itemKey="a['postdata']['itemKey']"
                    :descKey="a['postdata']['descKey']"
                    :selectedObject.sync="a['value']"
                    :isRequired="a['required'] == 1"
                    :errorMessage.sync="a['errorMessage']"
                  />
                  <DateTimePicker
                    v-if="a['type'] == 'DateTimePicker'"
                    :placeholder="a['placeholder']"
                    :value.sync="a['value']"
                    :isRequired="a['required'] == 1"
                    :errorMessage.sync="a['errorMessage']"
                  />
                  <RemarksBox v-if="a['type'] == 'RemarksBox'" :title="a['placeholder']" :text.sync="a['value']" />
                </div>
              </div>
              <div v-else>
                <div
                  v-if="['Free Demurrage', 'Free Storage', 'Free Detention'].includes(c['placeholder'])"
                  class="free-input-group"
                >
                  <Input
                    v-if="c['type'] == 'Input'"
                    :placeholder="c['placeholder']"
                    :inputValue.sync="c['value']"
                    :textType="c['datatype']"
                    :isRequired="c['required'] == 1"
                    :errorMessage.sync="c['errorMessage']"
                    :validator="c['validator']"
                  />
                  <div class="unit-toggle">
                    <button :class="['toggle-btn', { active: c['unit'] === 'D' }]" @click="$set(c, 'unit', 'D')">Days</button>
                    <button :class="['toggle-btn', { active: c['unit'] === 'H' }]" @click="$set(c, 'unit', 'H')">Hours</button>
                  </div>
                </div>
                <Input
                  v-else-if="c['type'] == 'Input'"
                  :placeholder="c['placeholder']"
                  :inputValue.sync="c['value']"
                  :textType="c['datatype']"
                  @fileChanged="dynamicFileChanged"
                  :isRequired="c['required'] == 1"
                  :errorMessage.sync="c['errorMessage']"
                  :multiFile="dynamicfield != '0'"
                  :validator="c['validator']"
                />
                <Dropdown
                  v-if="c['type'] == 'Dropdown'"
                  :placeholder="c['placeholder']"
                  :items="c['data']"
                  :itemKey="c['postdata']['itemKey']"
                  :selectedObject.sync="c['value']"
                  :isRequired="c['required'] == 1"
                  :errorMessage.sync="c['errorMessage']"
                />
                <InputQuery
                  v-if="c['type'] == 'InputQuery'"
                  :placeholder="c['placeholder']"
                  :items="c['data']"
                  :itemKey="c['postdata']['itemKey']"
                  :descKey="c['postdata']['descKey']"
                  :selectedObject.sync="c['value']"
                  :isRequired="c['required'] == 1"
                  :errorMessage.sync="c['errorMessage']"
                  @selected="dynamicFieldSelected($event, c)"
                />
                <DateTimePicker
                  v-if="c['type'] == 'DateTimePicker'"
                  :placeholder="c['placeholder']"
                  :value.sync="c['value']"
                  :isRequired="c['required'] == 1"
                  :errorMessage.sync="c['errorMessage']"
                />
                <RemarksBox
                  v-if="c['type'] == 'RemarksBox'"
                  :title="c['placeholder']"
                  :text.sync="c['value']"
                  :maxLength="500"
                />
                <div v-if="c['type'] == 'Input' && c['datatype'] == 'file'">
                  <div v-if="editDetails">
                    <div v-if="editDetails['attachment']"> Previous Attachment: {{ editDetails['attachment'] }} </div>
                    <div v-if="!editDetails['attachment'] && c['filename']">
                      <strong>Previous Attachment: </strong>
                      <span
                        class="file-link"
                        v-for="(file, filei) in c['filename'].split('|')"
                        :key="filei"
                        :title="c['attlink'] ? 'Click to view' : 'Viewing unavailable'"
                        @click="projectAttachment(file, c['attlink'] ? c['attlink'].split('|')[filei] : '')"
                      >
                        {{ file }}<span v-if="filei != c['filename'].split('|').length - 1">,</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <RemarksBox style="height: 60px" :text.sync="statusRemarks" />
          <InputQuery
            placeholder="Assign To"
            :items="assignToList"
            :selectedObject.sync="selectedAssignTo"
            itemKey="ID - Name"
            descKey="Employee Name"
          />
        </div>

        <!-- Container Update -->
        <div class="container-update" v-else-if="selectedCategory ? selectedCategory['key'] == 'c' : false">
          <Input placeholder="Job #" :inputValue="jobno" :isDisabled="true" />
          <InputQuery
            placeholder="Status"
            :isRequired="true"
            :items="pStatusList"
            itemKey="display"
            descKey="Status Desc"
            @selected="statusSelected"
            :selectedObject.sync="selectedStatus"
            :isDisabled="updateDetails === null || updateDetails === undefined"
            :errorMessage.sync="statusError"
          />
          <DateTimePicker placeholder="Start Date/Time" :value.sync="containerStart" />
          <DateTimePicker placeholder="Completion Date/Time" :value.sync="containerCompletion" />
          <DateTimePicker placeholder="Due Date/Time" :value.sync="containerDue" />
          <RemarksBox style="height: 70px" :text.sync="containerRemarks" />
          <TableBox
            title="Containers List"
            style="height: 300px; max-height: 300px"
            :tableData="containerList"
            :selectedRow.sync="selectedContainers"
            :maxSelection="-1"
          />
          <div class="button-container">
            <button @click="selectedContainers = containerList">Select All</button>
            <button @click="selectContainerForROT" v-if="updateDetails['ROT']"
              >Select All Containers belongs to {{ updateDetails['ROT'] }}</button
            >
            <button @click="selectedContainers = []">Clear All</button>
          </div>
        </div>

        <div class="update-cancel-button">
          <!-- <button @click="populate">Populate Test</button> -->
          <button @click="updateClicked" :disabled="disableUpdate">Update</button>
          <button @click="openClosePopup(false, true)">Cancel</button>
        </div>
      </div>
    </div>

    <div v-if="showAttachmentProjector" class="attachment-projector">
      <div class="attachment-projection">
        <object
          v-if="attachmentIsProjectable"
          :type="attachmentProjectorType"
          :data="attachmentProjectorData"
          draggable="false"
        >
        </object>
        <div v-else class="attachment-not-projectable-container">
          <span>
            {{ fileExtension }} files cannot be previewed.<br />
            Please download the file and view it instead.
          </span>
          <button @click="downloadAttachment">
            <img src="https://dsmlib.logistics.systems/Icons/Download.png" alt="Download icon" />
            Download
          </button>
        </div>
      </div>
      <div class="close-button" @click="closeProjector"> &times; </div>
    </div>
    <PopupV2
      :show="showPopupV2"
      @buttonClicked="popupButtonClicked"
      :title="popupTitle"
      :content="popupContent"
      :type="popupType"
    />

    <Loader :loadingText="loadingText" :isVisible="isLoading" />
  </div>
</template>

<script>
import axios from 'axios';
export default {
  components: {},
  data: function () {
    return {
      pShowPopup: false,
      selectedCategory: null,

      categoryList: [
        { desc: 'Document', key: 'd' },
        { desc: 'Status', key: 's' },
        { desc: 'Container', key: 'c' },
      ],

      dueTime: null,
      startTime: null,
      finishTime: null,
      selectedStatus: null,
      statusError: '',

      selectedDocCode: null,
      docCodeError: null,

      docRef: '',
      docRefError: null,

      collapseExpandTitle: 'Collapse All',
      allStatusesToBind: [],
      loadingText: 'Collecting Data',
      isLoading: false,
      loadStatus: false,
      dynamicfield: '',
      excel: '',
      email: '',
      maintablesave: '',
      emailFormat: '',
      currentStatusUI: [],
      noUIControl: '',
      docCodeWithStatus: [],
      // errorMessages: [],

      pDocStatusList: [],
      pDocTypeList: [],
      pStatusList: [],
      statusValue: '',
      assignToList: [],

      statusRemarks: '',
      selectedAssignTo: null,

      filesForDocWithoutStatus: [],

      // dynamicMapping: [
      //   // { key: 'Key from editDetails['dynamic']', placeholder: 'Placeholder of the item' },
      //   { key: 'docCode', placeholder: [ 'Doc Code' ] },
      //   { key: 'docType', placeholder: [ 'Doc Type' ] },
      //   { key: 'sets', placeholder: [ 'Sets' ] },
      //   { key: 'pages', placeholder: [ 'Pages' ] },
      //   { key: 'refno', placeholder: [ 'Ref #', 'Doc Ref No.' ] },
      // ],

      // dynamicMapping2: [
      //   // for fields not in dynamicMapping 1
      //   // { dynamickey: 'doccode', editdatakey: 'docCode' },
      //   // { dynamickey: 'doctype', editdatakey: 'docType' }
      //   // { dynamickey: 'amount', editdatakey: 'Amount' }
      //   // { dynamickey: 'sumpages', editdatakey: '' }
      //   { dynamickey: 'indicator', editdatakey: 'Indicator' },
      //   { dynamickey: 'cn', editdatakey: 'Consignment #' },
      //   { dynamickey: 'container', editdatakey: 'Container #' }
      //   // { dynamickey: 'trailerno', editdatakey: '' } //no edit value yet
      //   // { dynamickey: 'locationarea', editdatakey: '' } //no edit value yet
      //   // { dynamickey: 'destinationcode', editdatakey: '' } //no edit value yet
      //   // { dynamickey: 'truckno', editdatakey: '' } //no edit value yet

      // ],

      //#region attachment projector data fields
      showAttachmentProjector: false,
      attachmentProjectorFileName: '',
      attachmentProjectorType: '',
      attachmentProjectorData: '',

      containerStart: null,
      containerCompletion: new Date(),
      containerDue: null,
      containerRemarks: '',
      containerList: [],
      selectedContainers: [],

      showPopupV2: false,
      popupTitle: '',
      popupContent: '',
      popupType: '',
    };
  },
  computed: {
    disableUpdate: function () {
      if (this.selectedCategory) {
        if (this.selectedCategory['key'] == 's' && this.noUIControl) {
          return true;
        }
        return false;
      }
      return true;
    },

    attachmentIsProjectable: function () {
      if (
        !this.attachmentProjectorFileName ||
        !this.attachmentProjectorType // if either of these are blank
      ) {
        return false;
      }
      const filenameSplit = this.attachmentProjectorFileName.trim().split('.');
      const fileExtension = filenameSplit[filenameSplit.length - 1];
      const projectableExtensions = ['pdf', 'txt', 'json', 'mp3', 'wav', 'mp4', 'webm', 'ogg'];
      return this.attachmentProjectorType.startsWith('image/') || projectableExtensions.includes(fileExtension);
    },

    fileExtension: function () {
      if (this.attachmentProjectorFileName) {
        const split = this.attachmentProjectorFileName.split('.');
        return split[split.length - 1].toUpperCase();
      }
      return ''; // or any default value you prefer
    },

    filteredAttachments: function () {
      return this.editDetailsList.filter((d) => d['Attachment']);
    },

  },
  props: {
    //buttonText: { type: String, default: 'Update' },
    title: { type: String, default: 'Title here' },
    //docStatusList: { type: Array, default: function() { return [] } },
    //docTypeList: { type: Array, default: function() { return [] } },
    //statusList: { type: Array, default: function() { return [] } },
    showPopup: { type: Boolean, default: false },
    defaultCategory: { type: String, default: null },
    jobno: { type: String, default: '' },
    updateDetails: {
      type: Object,
      default: function () {
        return {};
      },
    },

    editDetailsList: {
      type: Array,
      default: function () {
        return [];
      },
    }, //for document, container category type
    editDetails: {
      type: Object,
      default: function () {
        return null;
      },
    }, //for status category type

    // Public events
    // updateClicked - fire when update is clicked if all the required fields are not empty
  },
  methods: {
    openClosePopup: async function (open, emit) {
      this.pShowPopup = open;
      if (emit) {
        this.$emit('update:showPopup', this.pShowPopup);
      }

      if (this.pShowPopup) {
        this.isLoading = true;
        const docStatus = await this.$apiCallV2(`/DocStatusUpdate/GetListMaster?masterFile=DOC_STATUS`);
        docStatus.forEach((d) => {
          d['Code - Description'] = [d['Doc Code'], d['Description']].filter(Boolean).join(' - ');
        });
        this.pDocStatusList = docStatus;
        const status = await this.$apiCallV2(`/DocStatusUpdate/GetListMaster?masterFile=STATUS`);
        status.forEach((s) => (s['display'] = `${s['Status']} - ${s['Status Desc']}`));
        this.pStatusList = status;
        this.isLoading = false;

        if (this.defaultCategory.toLowerCase() == 'container') {
          this.isLoading = true;
          this.loadingText = 'Getting Containers';

          const getJobDetails = await this.$apiCallV2(`/FreightForwarding/JobDetails?jobno=${this.jobno}`);
          this.containerList = getJobDetails['JobDetails']['Job']['ContDetail'];

          this.isLoading = false;
        }

        // this.$emit('update:docStatusList', this.pDocStatusList);
        this.pDocTypeList = [
          { title: 'Received Copy Status', key: 'Copy Received' },
          { title: 'Received Original Status', key: 'Original Received' },
          { title: 'Prepared Status', key: 'Prepared' },
          { title: 'Submitted Status', key: 'Submitted' },
          { title: 'Couriered Status', key: 'Couriered' },
        ];
        // this.$emit('update:docTypeList', this.pDocTypeList);
        // this.$emit('update:statusList', this.pStatusList);

        if (this.defaultCategory) {
          const defaultCategoryObj = this.categoryList.filter((c) => {
            return c['desc'].toUpperCase() == this.defaultCategory.toUpperCase();
          });
          this.selectedCategory = defaultCategoryObj[0];
        }
        await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'EMPLOYEE' }).then((result) => {
          this.assignToList = result.map((employee) => ({
            ...employee,
            'ID - Name': `${employee['EmployeeID']} - ${employee['Employee Name']}`,
          }));
        });
      } else {
        this.selectedCategory = null;
        this.dueTime = null;
        this.startTime = null;
        this.finishTime = null;
        this.selectedStatus = null;
        this.$emit('update:editDetails', null);
        this.$emit('update:editDetailsList', []);
        this.docRef = '';
        this.statusRemarks = '';
        this.selectedAssignTo = null;
        this.noUIControl = '';

        this.containerStart = null;
        this.containerCompletion = new Date();
        this.containerDue = null;
        this.containerList = [];
        this.selectedContainers = [];
      }

      const docCodeHasStatus = this.pDocStatusList.map((d) => {
        if (d['Copy Received'] || d['Couriered'] || d['Original Received'] || d['Prepared'] || d['Submitted']) {
          return d['Doc Code'];
        }
      });
      this.docCodeWithStatus = docCodeHasStatus.filter((d) => {
        return d;
      });

      this.allStatusesToBind = [];
      this.pDocTypeList.forEach((d) => {
        this.allStatusesToBind.push({
          title: d['title'],
          visible: false,
          docKey: d['key'],
          checked: false,
          expanded: true,
          start: null,
          received: null,
          due: null,
          attachment: null,
          remarks: '',
          assignTo: '',
          sets: '',
          page: '',
        });
      });

      if (this.pShowPopup && (this.editDetails || this.editDetailsList.length > 0)) {
        this.loadEditItems();
      }
    },

    downloadExcel: async function () {
      // Determine whether to download all data or only the displayed data
      let dataToDownload = [];

      // Iterate through the currentStatusUI array to extract data fields
      this.currentStatusUI.forEach((c) => {
        // Create an object to hold data fields
        let dataFields = {}; //new object for each currentstatusui
        let tempValue = '';
        if (Array.isArray(c)) {
          // If the current item is an array, iterate through its elements
          c.forEach((a) => {
            if (a['type'] == 'Input') {
              // For Input type, add the placeholder and value to data fields
              dataFields[a['placeholder']] = a['value'];
            }
          });
        } else if (c['type'] == 'DateTimePicker') {
          // Ensure that the value passed to the <DateTimePicker> component is a valid Date object or null
          tempValue = c['value'] ? this.$dateTime.getDateTime(c['value'], 'yyyy-MM-dd HHmm') : '';
        } else if (c['type'] == 'Input') {
          tempValue = c['value'] ?? '';
        } else if (c['type'] == 'InputQuery') {
          tempValue = c['value']?.[`${c['postdata']['descKey']}`] ?? '';
        }

        if (c['datatype'] != 'file') {
          dataFields = {
            '': c['placeholder'],
            ' ': tempValue ?? '',
          };
          // Push data fields into dataToDownload array
          dataToDownload.push(dataFields);
        }
      });

      // Convert dataToDownload to JSON string and remove tags if present
      let dataInString = JSON.stringify(dataToDownload);
      dataInString = this.removeTagWhenDownload(dataInString);
      dataToDownload = JSON.parse(dataInString);

      // Generate Excel file using dataToDownload
      this.$fullscreenLoading('Generating Excel');
      await this.$jsonToExcel(`${this.jobno} ${this.selectedStatus['Status Desc']}`, dataToDownload, 'xlsx', {});
      this.$fullscreenLoading();
    },

    removeTagWhenDownload: function (item) {
      item = item.replace(/(<)(.*?)(>)/g, '');
      return item;
    },

    sendEmail: function () {
      const subject = `${this.jobno} ${this.selectedStatus['Status Desc']}`;
      let body = this.emailFormat;
      body = body.replace('{Remarks}', this.statusRemarks);

      // Iterate through the currentStatusUI to replace placeholders with values
      for (const f of this.currentStatusUI) {
        const placeholder = f['#'];
        let tempValue = null;
        if (f['type'].trim().toUpperCase() == 'DATETIMEPICKER') {
          tempValue = f['value'] ? this.$dateTime.getDateTime(f['value'], 'yyyy-MM-dd HH:mm') : '';
        } else if (f['type'].trim().toUpperCase() == 'INPUTQUERY') {
          tempValue = f['value']?.[`${f['postdata']['descKey']}`] ?? '';
        } else if (f['type'].trim().toUpperCase() == 'INPUT' && f['datatype'].toUpperCase() == 'FILE') {
          //check if there is any pending attachment to be saved. As the email need the attachment link.
          if (typeof f['value'] === 'object' && f['value'].length > 0) {
            this.$showAlert('warning', 'Unsaved Document', 'Please save the document first before sending the email.');
            return;
          }

          if (f['attlink'] != '') {
            tempValue = f['attlink'];
          }
          if (tempValue) {
            body = `${body}\r\n${f['placeholder']}: ${encodeURI(tempValue)}`;
          }
        } else if (f['type'].trim().toUpperCase() == 'INPUT' && f['datatype'].toUpperCase() != 'FILE') {
          tempValue = f['value'];
        }

        // Replace placeholder with value in the email body template
        body = body.replace(`{${placeholder}}`, tempValue);
      }

      body = encodeURIComponent(body);
      const url = 'mailto:?subject=' + subject + '&body=' + body;
      window.location.href = url;
    },

    projectAttachment: async function (filename, attachmentLink) {
      if (filename && attachmentLink) {
        const jsReportPDF = await axios.get(attachmentLink, { responseType: 'arraybuffer' });

        this.attachmentProjectorFileName = filename;
        this.attachmentProjectorType = jsReportPDF['headers']['content-type'];

        const blob = new Blob([new Uint8Array(jsReportPDF.data)], { type: jsReportPDF['headers']['content-type'] });
        this.attachmentProjectorData = URL.createObjectURL(blob);
        this.showAttachmentProjector = true;
      } else {
        this.$showAlert('warning', 'Attachment Unavailable', 'Unable to view attachment');
      }
    },

    downloadAttachment: function () {
      const anchor = document.createElement('a');
      anchor['href'] = this.attachmentProjectorData;
      anchor['download'] = this.attachmentProjectorFileName;
      anchor.click();
    },

    closeProjector: function () {
      this.attachmentProjectorType = ''; // clear MIME Type and base64, because base64 is quite inefficient
      this.attachmentProjectorData = ''; // leaving it there after the projector is closed is quite wasteful
      this.showAttachmentProjector = false;
    },

    updateClicked: async function () {
      if (this.selectedCategory['key'] == 'd') {
        //document status update (array, use editDetailsList)
        let hasError = false;
        if (!this.selectedDocCode) {
          this.docCodeError = 'Doc Code is required';
          hasError = true;
        }
        if (!this.docRef) {
          this.docRefError = 'Doc Ref # is required';
          hasError = true;
        }

        if (!hasError) {
          const emitObj = {
            id: `${this.selectedDocCode['Doc Code']}-${this.docRef}`,
            details: {
              docCodeObj: this.selectedDocCode,
              docCode: this.selectedDocCode['Doc Code'],
              docRef: this.docRef,
              statuses:
                this.docCodeWithStatus.includes(this.selectedDocCode['Doc Code']) ?
                  this.allStatusesToBind.filter((a) => {
                    return a['visible'];
                  })
                : 'N/A',
              attachment:
                this.docCodeWithStatus.includes(this.selectedDocCode['Doc Code']) ? '' : this.filesForDocWithoutStatus,
            },
          };
          this.$emit('updateClicked', emitObj);

          this.selectedDocCode = null;
          this.docRef = '';
          this.filesForDocWithoutStatus = [];

          this.openClosePopup(false, true);
        }
      } else if (this.selectedCategory['key'] == 's') {
        //status update (object, use editDetails)
        if (!this.selectedStatus) {
          this.statusError = 'Please select status';
          return;
        }
        const auom = this.currentStatusUI.filter((c) => {
          return c['#'] == '4';
        })[0];
        const data = {
          finish: '',
          jobno: this.jobno,
          legno: '',
          tmsjino: '',
          seqno: '',
          status: this.statusValue,
          cn: '',
          statusseq: '',
          container: '',
          indicator: '',
          remarks: this.statusRemarks,
          // 'actfinishdate': this.finishTime ? this.$dateTime.getDateTime(this.finishTime, 'yyyy-MM-dd') : '',
          actfinishdate: '',
          // 'actfinishtime': this.finishTime ? this.$dateTime.getDateTime(this.finishTime, 'HHmm') : '',
          actfinishtime: '',
          duedate: this.dueTime ? this.$dateTime.getDateTime(this.dueTime, 'yyyy-MM-dd') : '',
          duetime: this.dueTime ? this.$dateTime.getDateTime(this.dueTime, 'HHmm') : '',
          txnguid: '',
          amount: '',
          amountuom:
            auom ?
              auom['placeholder'] == 'Sets' ?
                'SETS'
              : ''
            : '',
          ex_code: '',
          ex_rate: '',
          payeetype: '',
          payeecode: '',
          createnew: '1',
          unitprice: '',
          price: '',
          adjustprice: '',
          nettprice: '',
          chargescode: '',
          addtojobtxncharges: '',
          actstartdate: this.startTime ? this.$dateTime.getDateTime(this.startTime, 'yyyy-MM-dd') : '',
          actstarttime: this.startTime ? this.$dateTime.getDateTime(this.startTime, 'HHmm') : '',
          assignto: this.selectedAssignTo ? this.selectedAssignTo['EmployeeID'] : '',
          prodcode: '',
          sumpages: '',
          updatecnlastupstatus: '',
          stseqno: '0',
          priority: '',
          trailerno: '',
          truckno: '',
          docatt: '',
          filetype: '',
          attfile: '',
          sys: '',
        };

        let maxLengthExceed = false;
        let maxPrecisionExceed = false;

        this.currentStatusUI.forEach((c) => {
          const dType = c['datatype'];
          const length = c['value'] ? c['value'].length : 0;

          if (dType == 'number' || dType == 'text') {
            const maxLength = c['maxlength'];
            if (maxLength) {
              //checking on maxLength
              if (length > maxLength) {
                maxLengthExceed = true;
                this.$set(c, 'errorMessage', `Maximum length is ${maxLength}`);
              }

              //checking on maxPrecision
              if (dType == 'number') {
                const maxPrecision = c['maxprecision'];
                const precision = c['value'].split('.')[1]?.length;
                if (precision && maxPrecision !== 0) {
                  if (precision > maxPrecision) {
                    maxPrecisionExceed = true;
                    this.$set(c, 'errorMessage', `Maximum decimals is ${maxPrecision}`);
                  }
                }
              }
            }
          }
        });

        if (maxLengthExceed || maxPrecisionExceed) {
          return;
        }

        for (const c of this.currentStatusUI) {
          if (c['type'] == 'Input') {
            if (c['datatype'] == 'file' && typeof c['value'] == 'object') {
              if (c['value'].length > 0) {
                data['docatt'] = c['value'][0]['name'];
                data['filetype'] = c['value'][0]['type'];
                data['attfile'] = await this.$convertFile.toBase64(c['value'][0]);
              }
            } else {
              data[c['postdata']['postKey'][0]] = c['value'];

              const freeDmgField = this.currentStatusUI.find(c => c['placeholder'] == 'Free Demurrage');
              const freeStorageField = this.currentStatusUI.find(c => c['placeholder'] == 'Free Storage');

              if (freeDmgField || freeStorageField) {
                const dmgUnit = freeDmgField?.['unit'] ?? 'D';
                const storageUnit = freeStorageField?.['unit'] ?? 'D';
                data['amountuom'] = `${dmgUnit}|${storageUnit}`;
              }

              const freeDetentionField = this.currentStatusUI.find(c => c['placeholder'] == 'Free Detention');
              if (freeDetentionField) {
                data['amountuom'] = freeDetentionField['unit'] ?? 'D';
              }
            }
          } else if (c['type'] == 'Dropdown') {
            c['value'] ? (data[c['postdata']['postKey'][0]] = c['value'][c['postdata']['itemKey']]) : null;
          } else if (c['type'] == 'InputQuery') {
            if (c['value'] && c['data'] != undefined && c['data'].length > 0) {
              const valueKey = c['postdata']['itemKey'];
              c['dynamicvalue'] = c['value'][valueKey];
            }
            c['value'] ? (data[c['postdata']['postKey'][0]] = c['value'][c['postdata']['itemKey']]) : null;
          } else if (c['type'] == 'DateTimePicker') {
            if (Array.isArray(c['postdata']['postKey'])) {
              data[c['postdata']['postKey'][0]] =
                c['value'] ? this.$dateTime.getDateTime(c['value'], 'yyyy-MM-dd') : '';
              data[c['postdata']['postKey'][1]] = c['value'] ? this.$dateTime.getDateTime(c['value'], 'HHmm') : '';
            } else {
              data[c['postdata']['postKey']] =
                c['value'] ? this.$dateTime.getDateTime(c['value'], 'yyyy-MM-dd HHmm') : '';
            }
          }
        }
        data['finish'] = data['actfinishdate'] != '' ? 1 : 0;

        if (this.editDetails) {
          data['txnguid'] = this.editDetails['TxnGUID'];
          data['createnew'] = '0';
          data['statusseq'] = this.editDetails['#'];
          // data['docaction'] = 'E';
          data['docaction'] = this.editDetails['TxnGUID'] ? 'E' : 'N';
        }

        const dynamicfield = [];
        if (this.currentStatusUI) {
          for (const f of this.currentStatusUI) {
            let tempValue = null;
            if (f['type'].trim().toUpperCase() == 'DATETIMEPICKER') {
              tempValue = f['value'] ? this.$dateTime.getDateTime(f['value'], 'yyyy-MM-dd HHmm') : '';
            } else if (f['type'].trim().toUpperCase() == 'INPUTQUERY') {
              tempValue = f['dynamicvalue'] ?? '';
            } else if (f['type'].trim().toUpperCase() == 'INPUT' && f['datatype'].toUpperCase() == 'FILE') {
              //array length 0 - when use select a file then remove it
              //empty string - did not touch the atatchment button and no previous file

              if (typeof f['value'] === 'object' && f['value'].length > 0) {
                tempValue = [];
                //cater for multiple for (only for dynamic field status)
                for (const v of f['value']) {
                  tempValue.push({
                    docatt: v['name'],
                    filetype: v['type'],
                    attfile: await this.$convertFile.toBase64(v),
                    attlink: '',
                  });
                }
              } else {
                tempValue = {
                  docatt: f['filename'],
                  filetype: '',
                  attfile: '',
                  attlink: f['attlink'],
                };
              }
            } else if (
              (f['type'].trim().toUpperCase() == 'INPUT' && f['datatype'].toUpperCase() != 'FILE') ||
              f['type'].trim().toUpperCase() == 'REMARKSBOX'
            ) {
              tempValue = f['value'];
            }

            dynamicfield.push({
              '#': f['#'],
              columntype: f['datatype'] == 'file' ? 'Attachment' : f['type'],
              columnvalidation: '',
              savecolumn: f['postdata']['postKey'],
              value: tempValue ?? '',
            });
          }
        }

        if (this.dynamicfield == '1') {
          data['dynamicfieldvalue'] = dynamicfield;
        }
        data['maintablesave'] = this.maintablesave;

        const requiredEmpty = this.currentStatusUI.filter((c) => c['required'] == '1' && !c['value']);
        if (requiredEmpty.length > 0) {
          requiredEmpty.forEach((c) => this.$set(c, 'errorMessage', `${c['placeholder']} is required!`));
          return;
        }
        this.loading = true;
        this.loadingText = 'Updating Status';
        const result = await this.$apiCallV2('/DocStatusUpdate/UpdateStatusTask', data);
        this.loading = false;

        if (result[0]['Results'] == 0) {
          this.$emit('statusUpdated');
          this.openClosePopup(false, true);
        }
      } else if (this.selectedCategory['key'] == 'c') {
        //container status update (array, use updateDetails)
        if (!this.selectedStatus) {
          this.statusError = 'Please select status';
          return;
        }

        if (this.selectedContainers.length == 0) {
          this.showPopupV2 = true;
          this.popupTitle = 'No Container';
          this.popupContent = 'Please select at least 1 container to update';
          this.popupType = 'error';
          return;
        }

        const dataToPost = {
          finish: '1',
          jobno: this.jobno,
          status: this.selectedStatus['Status'],
          startdate: this.containerStart ? this.$dateTime.getDateTime(this.containerStart, 'yyyy-MM-dd') : '',
          starttime: this.containerStart ? this.$dateTime.getDateTime(this.containerStart, 'HHmm') : '',
          completedate:
            this.containerCompletion ? this.$dateTime.getDateTime(this.containerCompletion, 'yyyy-MM-dd') : '',
          completetime: this.containerCompletion ? this.$dateTime.getDateTime(this.containerCompletion, 'HHmm') : '',
          duedate: this.containerDue ? this.$dateTime.getDateTime(this.containerDue, 'yyyy-MM-dd') : '',
          duetime: this.containerDue ? this.$dateTime.getDateTime(this.containerDue, 'HHmm') : '',
          remarks: this.containerRemarks,
          // 'indicator': 'ROTBFI2011013',
          indicator: this.updateDetails['ROT'] ? this.updateDetails['ROT'] : '',
          containers: this.selectedContainers.map((c) => {
            return { contno: c['Container No'] };
          }),
        };

        const save = await this.$apiCallV2('/DocStatusUpdate/UpdateContainerStatus', dataToPost);
        if (save[0]['Results'] == 0) {
          this.showPopupV2 = true;
          this.popupTitle = 'Update Successful';
          this.popupContent = `Successfully update container status`;
          this.popupType = 'success';

          this.pShowPopup = false;
          this.$emit('update:showPopup', this.pShowPopup);
        } else {
          this.showPopupV2 = true;
          this.popupTitle = 'Update Failed';
          this.popupContent = `Update container status failed: ${save[0]['ErrMsg']}`;
          this.popupType = 'error';
        }
      }
    },
    dynamicFileChanged: function (attachment, placeholder) {
      const ui = this.currentStatusUI.filter((c) => {
        return c['placeholder'] == placeholder;
      });
      ui[0]['value'] = attachment;
    },
    docFileChangedWithoutStatus: function (e) {
      this.filesForDocWithoutStatus = [];
      this.filesForDocWithoutStatus = e;
    },
    docFileChangedWithStatus: function (file, index) {
      this.allStatusesToBind[index]['attachment'] = file;
    },
    // clearFields: function() {
    //   this.selectedCategory = null;
    //   this.selectedDocCode = null;
    //   this.selectedDocType = null;
    //   this.startDate = null;
    //   this.statusError = '';
    //   this.docRef = '';
    //   this.remarks = '';
    // },
    loadEditItems: async function () {
      if (this.defaultCategory == 'status') {
        //using editDetails
        if (this.editDetails['Due Time']) {
          let editDue = this.editDetails['Due Time'];
          editDue = `${editDue.substring(0, editDue.length - 2)}:${editDue.substring(editDue.length - 2, editDue.length)}`;
          this.dueTime = new Date(editDue);
        }
        if (this.editDetails['Start Time']) {
          let editStart = this.editDetails['Start Time'];
          editStart = `${editStart.substring(0, editStart.length - 2)}:${editStart.substring(editStart.length - 2, editStart.length)}`;
          this.startTime = new Date(editStart);
        }
        if (this.editDetails['Remarks']) {
          this.statusRemarks = this.editDetails['Remarks'].trim();
        }
        if (this.editDetails['Assign To']) {
          this.selectedAssignTo = this.assignToList.find((a) => a['EmployeeID'] == this.editDetails['Assign To']);
        }

        this.selectedStatus = this.pStatusList.find((s) => s['Status'] == this.editDetails['Status']);
        await this.statusSelected(this.selectedStatus);
        // console.log('this.currentstatusui',this.currentStatusUI)
        // this.currentStatusUI.forEach(c => {
        //   console.log(c);
        //   let mapping = null;
        //   console.log(c['postdata']['postKey'], c['postdata']['postKey'].length);
        //   if (c['postdata']['postKey'].length == 1) {
        //     console.log('testing here', c['postdata']['postKey'], this.dynamicMapping2);
        //     mapping = this.dynamicMapping2.find(f => c['postdata']['postKey'].includes(f['dynamickey']));
        //     console.log('mapping', mapping)
        //   }
        //   switch (c['type']) {
        //     case 'DateTimePicker':
        //       //only actfinishdate and actfinishtime uses DateTimePicker
        //       if (this.editDetails['Finish Time']) {
        //         c['value'] = this.editDetails['Finish Time'].toDate();
        //       }
        //       break;
        //     case 'Input':
        //       c['value'] = this.editDetails[mapping['editdatakey']] ?? '';
        //       console.log('c[value]', c['value'])
        //       break;
        //     //dropdown and inputquery to be done later
        //   }
        // })

        // this.dynamicMapping.forEach(m => {
        //   let defaultValue = this.currentStatusUI.find(s => m['placeholder'].includes(s['placeholder']));
        //   let editValue = this.editDetails[m['key']];
        //   console.log('editvalue', editValue);
        //   if (!defaultValue || !editValue) {
        //     return;
        //   }

        //   switch (defaultValue['type']) {
        //     case 'Input':
        //       defaultValue['value'] = editValue ? editValue.toString() : '';
        //       break;
        //     case 'Dropdown':
        //       break;
        //     case 'InputQuery':
        //       let obj = defaultValue['data'].find(d => d[defaultValue['postdata']['itemKey']].trim() == editValue ? editValue.trim() : '');
        //       defaultValue['value'] = obj;
        //       break;
        //     case 'DateTimePicker':
        //       break;
        //   }
        // });

        if (this.editDetails['Finish Time'] && this.currentStatusUI?.[0]?.['placeholder'] === 'Finish Time') {
          this.currentStatusUI[0]['value'] = new Date(this.editDetails['Finish Time']);
        }
      } else {
        //using editDetailsList
        this.$nextTick(() => {
          this.selectedDocCode = this.pDocStatusList.find(
            (d) => d['Doc Code'].trim() == this.editDetailsList[0]['Doc Code'].trim(),
          );
          this.docRef = this.editDetailsList[0]['Doc Ref #'];
          if (this.editDetailsList[0]['Status'] != 'N/A') {
            // Edit for document with status
            this.$nextTick(() => {
              this.editDetailsList.forEach((e) => {
                const statusToCheck = this.allStatusesToBind.find((s) => s['docStatus'] == e['Status']);
                statusToCheck['checked'] = true;
                statusToCheck['assignTo'] = e['Assign To'];
                statusToCheck['sets'] = e['Sets'] ? e['Sets'].toString() : '';
                statusToCheck['page'] = e['Page'] ? e['Page'].toString() : '';
                statusToCheck['remarks'] = e['Remarks'];
                statusToCheck['prevAttached'] = e['Attachment'];
                statusToCheck['due'] = e['Due Date'] ? new Date(e['Due Date']) : null;
                statusToCheck['received'] = e['Received Date'] ? new Date(e['Received Date']) : null;
                statusToCheck['start'] = e['Start Date'] ? new Date(e['Start Date']) : null;
              });
            });
          }
        });
      }
    },
    // populate: function() {
    //   //not using this function
    //   var allDetails = [];
    //   this.isLoading = true;
    //   this.loadingText = 'Getting All Status Types';
    //   this.pStatusList.forEach(async(s) => {
    //     var statusUI = await this.$apiCallV2(`/DocStatusUpdate/CheckUpdateStatusType?statusCode=${s['Status']}`);
    //     allDetails.push(statusUI['data']['statustype']['control']);
    //   });
    //   this.isLoading = false;
    //   // this.allStatusesToBind[0]['checked'] = true;
    //   // this.allStatusesToBind[1]['checked'] = false;
    //   // this.allStatusesToBind[2]['checked'] = true;
    //   // this.selectedDocType = this.docTypeList[2];
    //   // this.selectedDocCode = this.docCodeList[1];
    //   // this.startDate = new Date();
    //   // this.docRef = 'Auto Doc Ref'
    //   // this.remarks = 'My remarks here';
    // },
    collapseExpandClicked: function () {
      if (this.collapseExpandTitle == 'Collapse All') {
        this.collapseExpandTitle = 'Expand All';
        this.allStatusesToBind.forEach((s) => {
          s['expanded'] = false;
        });
      } else {
        this.collapseExpandTitle = 'Collapse All';
        this.allStatusesToBind.forEach((s) => {
          s['expanded'] = true;
        });
      }
    },
    individualCollapseExpand: function (index) {
      this.allStatusesToBind[index]['expanded'] ^= true;

      const expanded = this.allStatusesToBind.filter((a) => {
        return a['expanded'];
      });

      if (expanded.length == 0) {
        this.collapseExpandTitle = 'Expand All';
      } else if (expanded.length > 0) {
        this.collapseExpandTitle = 'Collapse All';
      } else if (expanded.length == this.allStatusesToBind.length) {
        this.collapseExpandTitle = 'Collapse All';
      }
    },
    statusSelected: async function (val) {
      //use by status category only
      this.noUIControl = '';
      this.maintablesave = '';
      this.currentStatusUI = [];
      if (!val) {
        return;
      }

      let seqno = '';
      if (this.editDetails) {
        seqno = this.editDetails['#'];
      }
      this.statusValue = val['Status'];
      this.loadStatus = true;
      const statusUI = await this.$apiCallV2(
        `/DocStatusUpdate/CheckUpdateStatusType?statusCode=${val['Status']}&jobno=${this.jobno}&seqno=${seqno}`,
      );
      this.dynamicfield = statusUI['dynamicfield'];
      this.excel = statusUI['excel'];
      this.email = statusUI['email'];
      this.currentStatusUI = statusUI['control'];
      this.maintablesave = statusUI['maintablesave'];
      this.emailFormat = statusUI['emailformat'];
      // this.errorMessages = [];
      // this.currentStatusUI.forEach(() => { this.errorMessages.push('hey') });
      // this.currentStatusUI.forEach(c => c['errorMessage'] = '');
      if (!this.currentStatusUI) {
        this.currentStatusUI = [];
        this.noUIControl = statusUI[0]['ErrMsg'];
      } else {
        const controlWithApi = [];
        this.currentStatusUI.forEach((c, i1) => {
          if (typeof c == 'object' && c['api']) {
            controlWithApi.push({ data: c, index: [i1] });
          } else if (Array.isArray(c)) {
            //not sure is it in use. API by right should only return array of object, not array of array
            c.forEach((cc, i2) => {
              if (cc['api']) {
                controlWithApi.push({ data: cc, index: [i1, i2] });
              }
            });
          }
        });

        const dynamicAPIPromises = [];
        for (const c of controlWithApi) {
          const i1 = c['index'][0];
          const i2 = c['index'][1];
          dynamicAPIPromises.push(
            this.$apiCallV2(
              `/DocStatusUpdate/DynamicPost?endpoint=${c['data']['api']}`,
              c['data']['postdata']['urldata'],
            ).then((resultData) => {
              if (i2 >= 0) {
                this.$set(this.currentStatusUI[i1][i2], 'data', resultData);
              } else {
                this.$set(this.currentStatusUI[i1], 'data', resultData);
              }
            }),
          );
        }

        await Promise.allSettled(dynamicAPIPromises);

        this.currentStatusUI.forEach((c) => {
          switch (c['type']) {
            case 'Input':
              if (c['value']) {
                c['value'] = c[['value']].toString();
              }
              if (c['datatype'] == 'file') {
                c['filename'] = c['value'];
              }
              //add validator to the object
              if (c['datatype'] === 'text') {
                c['validator'] = `${c['datatype']},${c['maxlength']}`;
              } else if (c['datatype'] === 'number') {
                c['validator'] = `integer,${c['maxlength']}`;
              } else {
                c['validator'] = '';
              }
              break;
            case 'Dropdown':
            case 'InputQuery':
              if (c['value']) {
                const selected = c['data'].find((s) => s[c['postdata']['itemKey']].trim() == c['value'].trim());
                c['value'] = selected;
              } else {
                c['value'] = null;
              }
              break;
            case 'DateTimePicker':
              if (c['value']) {
                const dateStr = `${c['value'].substring(0, 13)}:${c['value'].substring(13, 15)}`;
                const date = Date.parse(dateStr);
                if (date) {
                  c['value'] = new Date(date);
                } else {
                  c['value'] = null;
                }
              }
              break;
          }
        });
      }
      if (this.currentStatusUI.length > 0) {
        // Find all objects that match either "Doc Code" or "Doc Type" with type "InputQuery"
        const targetEntries = this.currentStatusUI.filter(
          (item) => (item.placeholder === 'Doc Code' || item.placeholder === 'Doc Type') && item.type === 'InputQuery',
        );

        targetEntries.forEach((targetEntry) => {
          if (Array.isArray(targetEntry.data)) {
            targetEntry.data.forEach((entry) => {
              if (targetEntry.placeholder === 'Doc Code') {
                entry['Code - Desc'] = `${entry['Doc Code']} - ${entry['Description']}`;
              } else if (targetEntry.placeholder === 'Doc Type') {
                entry['Code - Desc'] = `${entry['Doc Type']} - ${entry['Description']}`;
              }
            });
          }
          // Update the itemKey inside postdata
          if (targetEntry.postdata && typeof targetEntry.postdata === 'object') {
            targetEntry.postdata.itemKey = 'Code - Desc';
          }
        });
      }
      this.loadStatus = false;
    },
    statusChecked: async function (index) {
      const status = this.allStatusesToBind[index];
      if (status['checked']) {
        status['received'] = new Date();
      } else {
        const removeStatus = await this.$showAlert(
          'warning',
          `Removing Status ${status['docStatus']} (${status['docKey']})`,
          `Are you sure you want to remove status ${status['docStatus']} (${status['docKey']})?
          All details will be cleared if you remove this status.`,
          [{ text: 'Yes' }, { text: 'No' }],
        );

        if (removeStatus === 'Yes') {
          // Yes
          status['checked'] = false;
          status['start'] = null;
          status['received'] = null;
          status['due'] = null;
          status['attachment'] = null;
          status['remarks'] = '';
          status['assignTo'] = '';
          status['sets'] = '';
          status['page'] = '';
        } else {
          // No
          status['checked'] = true;
        }
      }
    },

    selectContainerForROT: function () {
      const rotCont = this.containerList.filter((c) => {
        const currentROT = c['ROT No'] ? c['ROT No'].trim() : '';
        return currentROT == this.updateDetails['ROT'].trim();
      });
      this.selectedContainers = rotCont;
    },

    popupButtonClicked: function () {
      this.showPopupV2 = false;
    },

    dynamicFieldSelected: function (val, field) {
      if (!val || field['placeholder'] !== 'Container #') return;

      const cmrField = this.currentStatusUI.find((c) => c['placeholder'] === 'CMR No');
      if (!cmrField) return;

      this.$set(cmrField, 'value', val['CMR No'] ?? '');
    },
  },
  //async mounted() {  },
  watch: {
    selectedDocCode: function (val) {
      if (val) {
        if (this.collapseExpandTitle == 'Expand All') {
          this.collapseExpandClicked();
        }

        this.allStatusesToBind.forEach((s) => {
          s['visible'] = Boolean(val[s['docKey']]);
          s['expanded'] = true;

          s['docStatus'] = val[s['docKey']];
        });
      } else {
        this.allStatusesToBind.forEach((a) => {
          a['visible'] = false;
          a['checked'] = false;
          a['expanded'] = true;
          a['start'] = null;
          a['received'] = null;
          a['due'] = null;
          a['attachment'] = null;
          a['remarks'] = '';
          a['assignTo'] = '';
          a['sets'] = '';
          a['page'] = '';
        });
      }
    },
    selectedCategory: function (_val) {
      this.selectedDocCode = null;
      this.currentStatusUI = [];
    },
    showPopup: function (val) {
      this.openClosePopup(val);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.doc-status-main {
  font-size: 12px;

  > .update-popup {
    position: fixed;
    top: 50px;
    left: 0;
    background-color: rgba(0, 0, 0, 0.2);
    height: calc(100% - 50px);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;

    > .update-content {
      position: relative;
      height: 95%;
      width: 90%;
      overflow: auto;
      background-color: white;
      padding: 5px;
      display: flex;
      flex-direction: column;

      > .title {
        text-align: center;
        font-weight: bold;
      }

      > .doc-update {
        display: flex;
        flex-direction: column;
        height: calc(100% - 110px);

        > .top-section {
          display: flex;
        }

        > .collapse-expand-button {
          align-self: flex-end;
        }

        > .status-scrollable {
          overflow: auto;
          height: 100%;

          > .status-section {
            border: 1px solid rgba(0, 0, 0, 0.5);
            border-radius: 5px;
            padding: 5px;
            padding-top: 10px;
            margin-top: 10px;
            margin-bottom: 15px;
            position: relative;
            height: max-content;

            > .status-wrapper {
              display: flex;

              > .individual-collapse-expand-button {
                position: absolute;
                right: 5px;
                top: 0;
                cursor: pointer;
                z-index: 99;
                transition: $transition-time;
              }

              > .status-title {
                position: absolute;
                top: -10px;
                background-color: white;
                padding: 0 5px;
                margin-left: 3px;
              }

              > .status-details-box {
                height: 100%;
                width: 100%;

                > .status-details {
                  display: flex;

                  > .attchment-area {
                    max-width: 33%;
                    overflow: hidden;
                  }

                  > * {
                    width: 100%;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    margin-right: 5px;
                  }
                }
              }

              > .status-details-box-collapse {
                display: flex;
                width: 100%;

                > * {
                  width: 100%;
                  margin-right: 5px;
                }
              }
            }
          }
        }
      }

      > .status-update {
        > .top-dates {
          display: flex;

          > * {
            width: 100%;
          }
        }

        > .excel-email-button {
          display: flex;
          margin-top: 5px;

          > button {
            margin-right: 5px;
          }
        }

        > .internal-loading {
          display: flex;
          align-items: center;

          > .internal-spinner {
            margin-left: 10px;
            height: 15px;
            width: 15px;
            border-radius: 100%;
            border-style: solid;
            border-color: black;
            border-width: 0px 0px 1px 1px;
            animation: spin 1s linear infinite;
          }
        }

        // > .dynamic-status {
        // }
      }

      > .update-cancel-button {
        display: flex;
        bottom: 5px;
        right: 5px;
        justify-content: right;

        > button {
          margin-left: 5px;
        }
      }

      > .container-update {
        > .button-container {
          display: flex;
          align-items: center;
          margin-top: 5px;

          > button {
            margin-right: 5px;
          }
        }
      }
    }
  }
  > .attachment-projector {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99999;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;

    > .attachment-projection {
      height: 95%;
      width: 80%;

      > object {
        height: 100%;
        width: 100%;
        object-fit: scale-down;
      }

      > .attachment-not-projectable-container {
        height: 100%;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.7);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        font-size: 40px;

        > span {
          margin: 10px 0 10px 0;
          color: white;
        }

        > button {
          height: 50px;
          width: 150px;
          margin: 10px 0 10px 0;
          font-size: 16px;

          > img {
            height: 24px;
            width: 24px;
          }
        }
      }
    }

    > .close-button {
      height: 50px;
      width: 50px;
      position: absolute;
      top: 10px;
      right: 10px;
      border-radius: 100px;
      background-color: white;
      text-align: center;
      font-size: xx-large;
      cursor: pointer;
      user-select: none;
    }
  }
}

.dynamic-horizontal {
  display: flex;

  > * {
    width: 100%;
    margin-right: 5px;
  }
}

.file-link {
  cursor: pointer;
  user-select: none;

  &:hover {
    text-decoration: underline;
  }

  &:active {
    background-color: black;
    color: white;
  }
}

@keyframes spin {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

.free-input-group {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;

  > .unit-toggle {
    display: flex;
    flex-shrink: 0;
    border: 1px solid #b3c4ff;
    border-radius: 4px;
    overflow: hidden;

    &.disabled {
      opacity: 0.5;
      pointer-events: none;
    }

    .toggle-btn {
      padding: 0 8px;
      height: 28px;
      font-size: 11px;
      border: none;
      background-color: #f0f0f0;
      color: #555;
      cursor: pointer;
      transition:
        background-color 0.15s,
        color 0.15s;

      &:first-child {
        border-right: 1px solid rgba(0, 0, 0, 0.15);
      }

      &.active {
        background-color: #6e6eff;
        color: #fff;
        font-weight: 600;
      }

      &:hover:not(:disabled):not(.active) {
        background-color: #b3c4ff;
        color: #fff;
      }
    }
  }
}
</style>
